module.exports = __webpack_public_path__ + "img/general3.eaf0e2c9.jpg";